import React                from "react"
import Img                  from "gatsby-image"
import RawHtml              from 'entrada-ui/RawHtml'
import PageTitle            from 'components/PageTitle'
import Seo                  from 'components/Seo'
import {
    Col,
    Row,
    Container
}                             from 'react-bootstrap'
import cx                     from 'utils/classnames'
import Link                   from 'components/Link'
// import styles                 from './styles.module.scss'

const PageTemplate = ({ pageContext: { data } }) => {
  const {
    content,
    slug,
    siteMetadata,
    title,
    wordpress_id,
    acf: {
      featured_image
    },
    yoast_meta
  } = data

  return (
    <>
      <Seo meta={yoast_meta} siteMetadata={siteMetadata} />
      <PageTitle title={title} />
      {featured_image &&
      <Container className="generic-hero-container">
        <Img fluid={featured_image.localFile.childImageSharp.fluid} className="generic-hero" />
      </Container>
      }

      <Container className="generic-container">
        <RawHtml html={content} />
      </Container>
    </>
  )
}
export default PageTemplate

